import {Breadcrumb, Card, Col, Divider, Flex, Row, Space, Tag} from "antd";
import React, {useEffect, useState} from "react";
import axios from "axios";
import Markdown from 'react-markdown'
import {NavLink} from "react-router-dom";
import {HomeOutlined} from "@ant-design/icons";

function Services() {

    const [content, setContent] = useState({});

    const [skeleton, setSkeleton] = useState(true);

    const apiKey = process.env.REACT_APP_STRAPI_CMS_API_KEY;

    const toggleSceleton = (value, key) => {
        if (key in value) {
            setSkeleton(false);
        } else {
            setSkeleton(true);
        }
    }

    const getServices = async () => {
        const response = await axios.get(
            process.env.REACT_APP_STRAPI_URL + "/api/service/?populate=*",
            {
                headers: {
                    'Authorization': 'Bearer ' + apiKey
                }
            }
        )
        console.log(response.data.data.attributes);
        const content = response.data.data.attributes;

        setContent(content);
        toggleSceleton(content, 'Title');
    }

    useEffect(() => {
        getServices().then(r => {});
    }, []);

    return (
            <>
                <Row gutter={24} className={"Content"} style={{paddingBottom: 0}}>
                    <Col span={12}>
                        <h1>{content.PageTitle}</h1>
                    </Col>
                    <Col span={12} style={{textAlign: "right"}}>
                        <Breadcrumb
                            style={{float: "right"}}
                            items={[
                                {
                                    href: '/',
                                    title: (
                                        <>
                                            <span>Home</span>
                                        </>
                                    ),
                                },
                                {
                                    title: 'Services',
                                },
                            ]}
                        />
                    </Col>
                </Row>

                <Row gutter={24} className={"Content"} style={{textAlign: "center", paddingTop: 0}}>
                    <Col span={24}>
                        <h2>{content.ExpertiseTitle}</h2>
                        <Divider className={"TransitionColors"} orientation="left">{content.QuoteOne}</Divider>
                    </Col>
                </Row>

                <Row className={"Content"} gutter={48} style={{textAlign: "center"}}>
                    {
                        (content?.ServicesList ?? []).map((service, value) => {
                            return <Col xs={24} sm={24} md={12} lg={6} xl={6} key={value}>
                                <h2>{service.ListTitle}</h2>
                                    <p style={{lineHeight: 1.4, fontWeight: 300}}>{service.ListSubTitle}</p>
                            </Col>
                        })
                    }
                </Row>

                <Row gutter={24} className={"Content"} style={{textAlign: "center"}}>
                    <Col span={24}>
                        <h2>{content.PricesTitle}</h2>
                        <Divider className={"TransitionColors"} orientation="right">{content.QuoteTwo}</Divider>
                    </Col>
                </Row>

                <Row className={"Content"} gutter={48} style={{textAlign: "center"}}>
                    {
                        (content?.PriceList ?? []).map((item, value) => {
                            return <Col xs={24} sm={24} md={12} lg={6} xl={6} key={value} style={{marginBottom: 32}}>
                                <h2>{item.Title}</h2>
                                <h1 style={{display: "inline-block"}}>{item.Price}</h1>
                                <small> / {item.Timeline}</small>
                                <p style={{lineHeight: 1.4, fontWeight: 300}}>{item.ListSubTitle}</p>
                                <div className={"List"}>
                                    <Markdown>
                                        {item.ExpertiseList}
                                    </Markdown>
                                </div>
                            </Col>
                        })
                    }
                </Row>
            </>
    )
}

export default Services